import { PrismicImage, PrismicLink } from "@prismicio/react";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.FourHundredFourSlice} FourHundredFourSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FourHundredFourSlice>} FourHundredFourProps
 * @param {FourHundredFourProps}
 */

const FullProjectItemMobile = ({ project, label, i, isLast,index }) => {

  return <div className={`mb-20 w-1/2 ${i % 2 === 0 ? 'pr-2 md:pr-5' : 'pl-2 md:pl-5 translate-y-28'} ${isLast ? 'pb-28' : ''}`}>
    <div className="mb-2">
      <PrismicLink field={project}>
        <div className={`tag-rea rounded-t-lg text-center py-1 bg-${project.data.preview_tag} ${i % 2 === 0 ? 'hidden' : ''}`}>
          {label}
        </div>
        <PrismicImage field={project.data.preview_picture} className={`${i % 2 === 0 ? 'rounded-t-full border-b-2' : 'rounded-b-full border-t-2'} border-dark-grey object-cover aspect-[3/4] w-full h-full`}  loading={index === 0 ? '' : 'lazy'}/>
        <div className={`tag-rea rounded-b-lg text-center py-1 bg-${project.data.preview_tag} ${i % 2 === 0 ? '' : 'hidden'}`}>
          {label}
        </div>
      </PrismicLink>
    </div>
    <div className={`text-info ${i % 2 === 0 ? 'text-end' : 'text-start'}`}>
      <PrismicRichText
        field={project.data.preview_name}
        components={{
          heading2: ({ children }) => <h2 className="h3">{children}</h2>
        }}
      />
    </div>
  </div>
}

export default FullProjectItemMobile